import { StackedState } from "client/Misc/stackedState";
import { Guid } from "client_legacy/ndaw/guid";
import {
	useCallback,
	useEffect,
	useState
} from "react";

export type RegisterElement = () => (() => void);

export function useContainsElementStack(
	onContainsElementChange: (value: boolean) => void
): RegisterElement {
	const [stackState] = useState(
		(): StackedState<true> => {
			return new StackedState<true>();
		}
	);

	useEffect(
		(): EffectWithDestructorResult => {
			const callback = (value: true | undefined): void => {
				onContainsElementChange(value ?? false);
			};

			stackState.onTopValueChange(callback);

			return () => stackState.offTopValueChange(callback);
		},
		[
			onContainsElementChange,
			stackState
		]
	);

	useEffect(
		(): EffectWithDestructorResult => {
			return (): void => {
				stackState.destroy();
			};
		},
		[stackState]
	);

	return useCallback(
		(): (() => void) => {
			const handle: Guid = stackState.push(true);
			return (): void => void stackState.remove(handle);
		},
		[stackState]
	);
}